import { jsx as _jsx } from "react/jsx-runtime";
import * as Colors from './colors';
import { split } from './common';
export function renderXml(source) {
    const parts = split(source);
    const result = [];
    let color = 'white';
    let isProperty = false;
    let inElement = false;
    let key = 0;
    for (const token of parts) {
        let tokenHandled = false;
        if (!isProperty && token === '"') {
            isProperty = true;
            color = Colors.attributeValueColor;
            tokenHandled = true;
        }
        if (token === '<' || token === '>' || token === '?' || token === '/') {
            color = Colors.signColor;
        }
        if (token === ' ') {
            if (inElement) {
                color = Colors.attributeNameColor;
            }
            else {
                color = Colors.defaultColor;
            }
        }
        result.push(_jsx("span", { style: { color: color }, children: token }, key));
        key++;
        if (tokenHandled) {
            continue;
        }
        if (token === '<') {
            color = Colors.elementColor;
            inElement = true;
        }
        if (isProperty && token === '"') {
            isProperty = false;
            color = Colors.defaultColor;
        }
        if (token === '>') {
            color = Colors.defaultColor;
            inElement = false;
        }
        if (token === '?' || token === '/') {
            color = Colors.elementColor;
        }
    }
    return result;
}
